import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NavigationExtras, Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "../../authentication/oidc/auth.service";
import { ProjectGetAllGQL } from "../../../generated/graphql";
import { SnackBarService } from "./snack.bar.service";

// a key string of localStorage to indicate "current selected project id"
const SELECTED_PROJECT_KEY: string = "selected_project";
const PROJECT_QUERY_PARAMS_KEY = "project_id";

@Injectable()
export class ProjectService {
  Projects: any[] = [];

  private _Current: string = "";
  get Current(): string {
    return this._Current;
  }
  set Current(value: string) {
    this._Current = value;
    this.Current$.next(this._Current);
    this.SetLocalStorageProjectId();
  }
  Current$: BehaviorSubject<string> = new BehaviorSubject("");

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authSvc: AuthService,
    private projectGQL: ProjectGetAllGQL,
    private snackBarService: SnackBarService
  ) {}

  Init() {
    this.initProjects();
  }

  private initProjects() {
    this.projectGQL.fetch().subscribe(
      (result) => {
        this.Projects = result.data.getAllProject;
        if (this._Current) {
          if (!this.GetProjectById(this._Current)) {
            location.href = "/";
          }
        }
        this.initSelectedProject();
      },
      (err) => {
        this.snackBarService.show(err.graphQLErrors[0].message);
      }
    );
  }

  private initSelectedProject() {
    // Look for selected project of previous session.
    let prevSelectedProjectId = this.GetLocalStorageProjectId();
    if (this.Projects.length != 0) {
      if (prevSelectedProjectId && this.GetProjectById(prevSelectedProjectId)) {
        this._Current = prevSelectedProjectId;
      } else {
        this.Current = this.Projects[0].project_id;
      }
    }
    if (!this._Current) this._Current = prevSelectedProjectId;
    this.Current$.next(this._Current);
  }

  GetAllProjects() {
    return this.Projects;
  }

  GetCurrentProject() {
    return this.GetProjectById(this._Current);
  }

  GetProjectById(projectId: string) {
    let project = this.Projects.find((x) => x.id === projectId);
    return project;
  }

  SwitchProjectParams(projectId?: string) {
    if (projectId) {
      if (projectId !== this._Current) this.Current = projectId;
      this.replaceQueryParams();
    } else {
      this.Current$.subscribe(() => this.replaceQueryParams());
    }
  }

  private replaceQueryParams() {
    if (!this._Current) this.getParams();

    let param = {};
    param[PROJECT_QUERY_PARAMS_KEY] = this._Current;
    let extra: NavigationExtras = {
      queryParams: param,
      queryParamsHandling: "merge",
      replaceUrl: true,
    };

    this.router.navigate([], extra);
  }

  private SetLocalStorageProjectId() {
    let selectedProject = localStorage.getItem(SELECTED_PROJECT_KEY);
    let userSelection = {};

    let saveLocal = (local_data: any) => {
      local_data[this.authSvc.userContext.userId] = this._Current;
      localStorage.setItem(SELECTED_PROJECT_KEY, JSON.stringify(local_data));
    };

    try {
      userSelection = JSON.parse(selectedProject) || {};
      saveLocal(userSelection);
    } catch {
      saveLocal(userSelection);
    }
  }

  GetLocalStorageProjectId() {
    let selectedProject = localStorage.getItem(SELECTED_PROJECT_KEY);
    let projectId: string = null;
    if (!selectedProject) {
      let user_selection = JSON.parse(selectedProject);
      projectId = user_selection[this.authSvc.userContext.userId];
    }

    if (!projectId) {
      projectId = this._Current;
    }
    return projectId;
  }

  private getParams() {
    let snapshotParam: any = this.activatedRoute.queryParams;
    if (snapshotParam._value.project_id) {
      this._Current = snapshotParam._value.project_id;
      this.Current$.next(this._Current);
    }
  }
}
